export const SERVICE_LIST_FETCH = 'SERVICE_LIST_FETCH';
export const SERVICE_LIST_SUCCESS = 'SERVICE_LIST_SUCCESS';
export const SERVICE_LIST_FAILURE = 'SERVICE_LIST_FAILURE';

export const DELETE_SERVICE_FETCH = 'DELETE_SERVICE_FETCH';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const DELETE_SERVICE_FAILURE = 'DELETE_SERVICE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/ServiceList/actionTypes.js